import { markComplete } from '@/api/course/courseapi'
export const MarkCompleteMixin = {
  data () {
    return {
      data1:'hi'
    }
  },
  methods: {
    async markComplete (payload) {
      try {
        const data = await markComplete(payload)
        console.log(data)
        return true
      } catch (error) {
        console.log(error)
        return false
      }
    }
  }
  
}


export const percentageMixin = {

  data () {
    return {
      testing:'1'
    }
  },

  computed:{
    calculatePercentage () {
      const totalLesson = this.myCourseList.classLesson.length
      let lessonCount = 0
      this.myCourseList.classLesson.forEach(ele => {
        if (ele.lesson_complete_count > 0) {
          lessonCount++

        }
      })

      // [totalLesson - 1].lesson.lesson_complete_count

      return (Math.round(lessonCount / totalLesson * 100))
    },

    calculatePercentageCourse () {
      if (this.myCourseList.courseComplete === 0) {
        return 0
      } else {
        return 100
      }

    },
   
    calculateComplete () {
      let lessonCount = 0
      this.myCourseList.classLesson.forEach(ele => {
        if (ele.lesson_complete_count > 0) {
          lessonCount++

        }
      })
      return  lessonCount

    }
  }
}